import { useEffect, useRef, useState } from 'react';
import { Bell, Search, ShoppingCart, ChevronDown, LogOut, CircleUserRound, Phone, ChevronUp,
         CreditCard, Headphones, Package, RefreshCw,
 } from 'lucide-react';
import { FaTelegramPlane, FaInstagram, FaWhatsapp  } from "react-icons/fa";
import { LiaFacebook } from "react-icons/lia";
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';
import { BASE_URL, appConfig } from '../apiConfig';
import Cookies from 'js-cookie';
import { useAuth } from '../context/AuthProvider';

export default function Header() {
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [ModalPhones, setModalPhones] = useState(false);
  const dropdownRef = useRef(null);
  const { user, token, logout } = useAuth();
  const [config, setConfig] = useState(() => {
    const configCookie = Cookies.get('config');
    try {
      return configCookie ? JSON.parse(configCookie) : [];
    } catch (error) {
      return [];
    }
  });
  const [CountCart, setCountCart] = useState(0);

  useEffect(() => {
    const configCookie = Cookies.get('config');
    if (configCookie) {
      try {
        setConfig(JSON.parse(configCookie));
      } catch (error) {
        console.error('Error parsing config cookie:', error);
      }
    }
  }, []);

  useEffect(() => {
    const updateCartCount = () => {
      try {
        const cart = JSON.parse(Cookies.get('cart') || '[]');
        setCountCart(cart.length);
      } catch (error) {
        console.error('Error parsing cart cookie:', error);
        setCountCart(0);
      }
    };

    updateCartCount();
    
    const cartInterval = setInterval(updateCartCount, 2000);
    return () => clearInterval(cartInterval);
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = async () => {
    try {
      // Best to try server logout, but always clear local state
      if (token) {
        await axios.post(
          BASE_URL + '/api/logout',
          { token },
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        ).catch(err => console.error("Server logout error:", err));
      }
    } finally {
      logout();
      setDropdownOpen(false);
      navigate('/login');
    }
  };

  const getUserInfo = () => {
    if (!user) return null;
    
    if (user.role === 1 || user.role === 2) {
      return user.admin_info || null;
    } else if (user.role === 3) {
      return user.confirmator || null;
    } else if (user.role === 0) {
      return user.saller_info_active || null;
    }
    
    return null;
  };

  const getUserInitial = () => {
    const userInfo = getUserInfo();
    if (!userInfo || !userInfo.name) return '';
    return userInfo.name.charAt(0).toUpperCase();
  };

  const getUserName = () => {
    const userInfo = getUserInfo();
    if (!userInfo || !userInfo.name) return '';
    return userInfo.name;
  };

  const getUserRole = () => {
    if (!user) return '';
    if (user.role === 1) return 'Admin';
    if (user.role === 2) return 'Assistant';
    if (user.role === 3) return 'Confirmateur';
    if (user.role === 0) return 'Vendeur';
    return '';
  };

  const userInfo = getUserInfo();

  return (
    <header className="bg-white border-b h-[9vh] border-gray-200 sticky top-0 z-[99] shadow-sm">
      <div className="px-4 sm:px-6 lg:px-6">
        <div className="flex h-[9vh] items-center justify-between">
          <div className="flex items-center max-lg:w-[30%] cursor-pointer max-xl:hidden">
          <img
              src={`/images/${appConfig.slug}-logo.png`}
              alt={appConfig.name}
              width={appConfig.slug === 'nextlead' ? 160 : 90}
              height={100}
            />
          </div>
          <div className="flex items-center max-lg:w-[30%] cursor-pointer xl:hidden">
          <img
              src={`/images/${appConfig.slug}-logo.png`}
              alt={appConfig.name}
              width={appConfig.slug === 'nextlead' ? 150 : 90}
              height={100}
            />
          </div>

          <div className="hidden md:flex items-center space-x-4 flex-1 max-w-lg mx-8">
            <div className="relative flex-1">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4" />
              <input
                type="text"
                placeholder="Search anything..."
                className="w-full text-xs pl-10 pr-4 py-2 border border-gray-200 rounded-lg bg-gray-50 focus:bg-white focus:border-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-200 transition-all duration-200"
              />
            </div>
            <button className="px-4 py-2 border border-gray-200 rounded-lg hover:bg-gray-50 flex items-center space-x-2">
              <span className="text-xs">Filter</span>
            </button>
          </div>

          <div className="flex items-center space-x-3 relative ">
            {
              user.role !== 4 && (
                <div className='flex items-center gap-3'> 
                  <div className="flex items-center gap-3 ">
                    {config?.telegram && (
                      <Link className="cursor-pointer" target="_blank" to={config.telegram}>
                        <FaTelegramPlane className="text-[#3390ec] w-4.5 h-4.5" />
                      </Link>
                    )}
                    {config?.instagram && (
                      <Link className="cursor-pointer" target="_blank" to={config.instagram}>
                        <FaInstagram className="text-[#de317f] w-4.5 h-4.5" />
                      </Link>
                    )}
                    {config?.facebook && (
                      <Link className="cursor-pointer" target="_blank" to={config.facebook}>
                        <LiaFacebook className="text-[#0866ff] w-5 h-5" />
                      </Link>
                    )}

                    <div className="relative inline-block text-left max-xl:hidden">
                        {/* Dropdown button */}
                        <div onClick={() => setModalPhones(prev => !prev)} className="flex items-center cursor-pointer bg-gray-50 rounded-md gap-2 py-2 px-3 hover:bg-gray-100 transition">
                          <Phone className="w-3.5 h-3.5 text-gray-700" />
                          {
                            ModalPhones ?
                              <ChevronUp className="w-3 h-3 text-gray-700" />
                              :
                              <ChevronDown className="w-3 h-3 text-gray-700" />
                          }
                        </div>

                        {/* Dropdown menu */}
                        <div
                            className={`absolute ${ModalPhones ? 'block' : 'hidden'} mt-1 w-52 bg-white border border-gray-200 rounded-md shadow-lg z-10`}
                          >
                            <ul className="py-2">
                              {config?.phone_support && (
                                <li className="flex items-center gap-2 px-3 py-2 text-xs text-gray-700 hover:bg-gray-100 cursor-pointer">
                                  <Headphones className="w-4 h-4" />
                                  <a href={`tel:${config.phone_support}`} className="block">
                                    Support: {config.phone_support}
                                  </a>
                                </li>
                              )}
                              {config?.phone_stock && (
                                <li className="flex items-center gap-2 px-3 py-2 text-xs text-gray-700 hover:bg-gray-100 cursor-pointer">
                                  <Package className="w-4 h-4" />
                                  <a href={`tel:${config.phone_stock}`} className="block">
                                    Stock: {config.phone_stock}
                                  </a>
                                </li>
                              )}
                              {config?.phone_payment && (
                                <li className="flex items-center gap-2 px-3 py-2 text-xs text-gray-700 hover:bg-gray-100 cursor-pointer">
                                  <CreditCard className="w-4 h-4" />
                                  <a href={`tel:${config.phone_payment}`} className="block">
                                    Paiement: {config.phone_payment}
                                  </a>
                                </li>
                              )}
                              {config?.phone_change && (
                                <li className="flex items-center gap-2 px-3 py-2 text-xs text-gray-700 hover:bg-gray-100 cursor-pointer">
                                  <RefreshCw className="w-4 h-4" />
                                  <a href={`tel:${config.phone_change}`} className="block">
                                    Échange: {config.phone_change}
                                  </a>
                                </li>
                              )}
                            </ul>
                          </div>

                      </div>

                  </div>
                  <div className='w-1 h-8 border-l border-gray-200'></div>
                  <Link to="/cart" className="relative">
                    <ShoppingCart className="h-4 w-4" />
                    {CountCart > 0 && (
                      <span className="absolute bg-[var(--color-primary-500)] text-xs w-4 h-4 pt-0.1 top-[-12px] right-[-10px] text-center text-white rounded-full">
                        {CountCart}
                      </span>
                    )}
                  </Link>
                  <button className="relative p-2 rounded-lg hover:bg-gray-100">
                    <Bell className="h-4 w-4" />
                    <span className="absolute -top-1 -right-1 h-4 w-4 bg-red-500 text-white text-xs rounded-full flex items-center justify-center animate-pulse">
                      3
                    </span>
                  </button>
                </div>
              )
            }

            <div ref={dropdownRef} className="relative">
              <button
                onClick={() => setDropdownOpen(!dropdownOpen)}
                className="flex items-center space-x-2 pl-3 border-l border-gray-200 cursor-pointer"
              >
                {userInfo?.logo ? (
                    <img src={`${BASE_URL}/storage/${userInfo.logo}`} className="h-8 w-8 rounded-full object-cover" />
                  ) : (
                    <div className="h-8 w-8 bg-gradient-to-r from-[var(--color-primary-500)] to-[var(--color-primary-300)] rounded-full flex items-center justify-center text-white font-semibold">
                      {getUserInitial()}
                    </div>
                  )}
                <div className="hidden lg:block text-left space-y-[-2px]">
                  <p className="text-[11px] font-semibold text-gray-900">{getUserName()}</p>
                  <p className="text-[11px] text-gray-500">{getUserRole()}</p>
                </div>
                <ChevronDown className="h-4 w-4 text-gray-400 hidden lg:block" />
              </button>

              {dropdownOpen && (
                <div className="absolute bg-white right-5 mt-2 w-44 border border-gray-300 shadow-lg rounded-md">
                  <Link to="/profile">
                    <button
                      onClick={() => {
                        setDropdownOpen(false);
                      }}
                      className="block flex gap-2 cursor-pointer my-1 w-full text-left px-4 py-2 text-xs text-gray-700 hover:bg-stone-100"
                    >
                      <CircleUserRound size={18} />
                      Profile
                    </button>
                  </Link>
                  <button
                    onClick={handleLogout}
                    className="block flex gap-2 cursor-pointer my-1 w-full text-left px-4 py-2 text-xs text-gray-700 hover:bg-stone-100"
                  >
                    <LogOut size={18} />
                    Déconnecter
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
